module.exports = __webpack_public_path__ + "1b78574b361f178ee30908c155efa2fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/stop-sign.png
// module id = 3186
// module chunks = 1